import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HomePageBanner.css";
import Promo1 from "../../assets/Images/PromoCards/Promo1.png";
import Promo2 from "../../assets/Images/PromoCards/Promo2.png";
import Promo3 from "../../assets/Images/PromoCards/Promo3.png";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
const HomeBanner = () => {
  const navigate = useNavigate();


  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      once: true      // Only animate once
    });
  }, []);

  return (
    <div className="banner-container-images d-flex align-items-center">
      <div
        className="text-white home-banner-sub-div"
        data-aos="fade-up" // 👈 Animation effect
      >
        <h1
          className="ff-poppins fw-600 fs-48 home-banner-heading"
          data-aos="fade-right"
          data-aos-delay="100"
        >
          Your Trusted Online <br />  Shopping Destination
        </h1>

        <p
          className="home-banner-lead ff-poppins fw-500 fs-24"
          data-aos="fade-left"
          data-aos-delay="300"
        >
          {/* Sale Upto <br />
      <span className="home-banner-lead-span">48%/</span> off */}
          Connecting buyers with quality products
          <br />
          from verified sellers. Seamless shopping.
          <br />
          Secure payments. Fast delivery nationwide.
        </p>
        <div className="row row-cols-lg-2">
          <div
            className="mt-4 home-banner-btn-div"
            data-aos="zoom-in"
            data-aos-delay="500"
            onClick={() => navigate('/shop')}
          >
            <button className="ff-poppins fw-550 fs-14 btn btn-light promo-shop-now-btn ">
              Shop Now
              <span className="fc-white ps-1  ">
                <FaArrowRightLong />
              </span>
            </button>
          </div>
          <div
            className="mt-4 home-banner-btn-div"
            data-aos="zoom-in"
            data-aos-delay="500"
          >
            <button className="ff-poppins fw-550 fs-14 btn btn-light promo-shop-now-btn ">
              <a href="https://play.google.com"
                target="_blank"
                style={{ textDecoration: "none", color: "white" }}
              > Become a Seller {" "}</a>
              <span className="fc-white ps-2">
                <FaArrowRightLong />
              </span>
            </button>
          </div>
        </div>

      </div>
    </div>

  );
};

export default HomeBanner;
